import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/login";
import Admin from "./pages/admin";
import Preview from "./pages/Preview";
import ProtectedRoute from "./auth/ProtectedRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public homepage */}
        <Route path="/" element={<Preview />} />

        {/* Login */}
        <Route path="/login" element={<Login />} />

        {/* Secured dictionary page */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;